<ion-item lines="none" (click)="openPicker()" button="true" detail="false">
  <ion-label position="stacked">{{ label() }}</ion-label>
  <div class="date-display">
    @if (currentValue()) {
      <span class="date-value">{{ currentValue() | date: DATE_DISPLAY_FORMAT }}</span>
    } @else {
      <span class="date-placeholder">Select a date</span>
    }
    <ion-icon name="calendar-outline" class="calendar-icon"></ion-icon>
  </div>
</ion-item>

@if (getErrorMessage()) {
  <div class="field-error">
    <span>{{ getErrorMessage() }}</span>
  </div>
}

@if (isOpen()) {
  <div class="date-picker-overlay" (click)="onCancel()">
    <div class="date-picker-dialog" (click)="$event.stopPropagation()">
      <ion-datetime
        presentation="date"
        [value]="presentationValue()"
        [min]="min()"
        [max]="max()"
        (ionChange)="onDateChanged($event)"
      ></ion-datetime>
    </div>
  </div>
}
